import type { ReactNode } from 'react'

/**
 * A card's way further, in its head: a word naming where it goes, quiet until
 * pointed at. A button where it changes a view in place; a card that leaves
 * for another page passes a router `Link` with the same class instead.
 */
export function CardLink({
  onClick,
  children,
}: {
  onClick: () => void
  children: ReactNode
}) {
  return (
    <button type="button" className="card__link" onClick={onClick}>
      {children}
    </button>
  )
}
